export default {
  "profile.title": "My profile",
  "profile.bookings": "My bookings",
  "profile.favorites": "Favorites",
  "profile.settings": "Settings",
  "profile.editProfile": "Edit profile",
  "profile.save": "Save changes",
  "profile.cancel": "Cancel",
  "profile.fullName": "Full name",
  "profile.email": "Email",
  "profile.phone": "Phone",
  "profile.bio": "About me",
  "profile.location": "Location",
  "profile.changePhoto": "Change photo",
  "profile.upcoming": "Upcoming",
  "profile.past": "Past",
  "profile.cancelled": "Cancelled",
  "profile.noBookings": "You don't have any bookings yet",
  "profile.exploreTours": "Explore tours",
  "profile.bookingId": "Booking",
  "profile.date": "Date",
  "profile.status": "Status",
  "profile.total": "Total",
  "profile.viewDetails": "View details",
  "profile.bookAgain": "Book again",
  "profile.noFavorites": "You don't have any favorites yet",
  "profile.remove": "Remove",
  "profile.notifications": "Notifications",
  "profile.language": "Language",
  "profile.password": "Change password",
  "profile.currentPassword": "Current password",
  "profile.newPassword": "New password",
  "profile.confirmPassword": "Confirm password",
  "profile.deleteAccount": "Delete account",
  "profile.deleteWarning": "This action cannot be undone",
  "profile.memberSince": "Member since",
  "profile.logout": "Log out",
  "profile.statusConfirmed": "Confirmed",
  "profile.statusPending": "Pending",
  "profile.statusCancelled": "Cancelled",
  "profile.statusCompleted": "Completed",
  "profile.backToBookings": "Back to bookings",
  "profile.backToBookingDetail": "Back to booking",
  "profile.bookingNotFound": "Booking not found",
  "profile.bookingDetails": "Booking details",
  "profile.bookingDate": "Booking date",
  "profile.paymentInfo": "Payment information",
  "profile.paymentMethods": "Payment methods",
  "profile.paymentsSecureTitle": "Secure payments with Mercado Pago",
  "profile.paymentsSecureBody": "Your payments are processed securely through Mercado Pago. BajApp Xperiences never stores your card details; you enter them directly with Mercado Pago each time you book.",
  "profile.paymentsMethodsNote": "Accepted methods: credit and debit cards, OXXO, and bank transfer (SPEI), via Mercado Pago.",
  "profile.paymentMethod": "Payment method",
  "profile.paymentId": "Payment ID",
  "profile.providerContact": "Provider contact",
  "profile.adults": "Adults",
  "profile.children": "Children",
  "profile.guests": "travelers",
  "profile.cancelReason": "Cancellation reason",
  "profile.cancelComment": "Comments (optional)",
  "profile.cancelCommentPlaceholder": "Tell us more about why you are cancelling...",
  "profile.cancelWarning": "This action is irreversible. Refund policies apply according to the cancellation policy.",
  "profile.goBack": "Go back",
  "profile.confirmCancel": "Confirm cancellation",
  "profile.cancelSuccess": "Reservation cancelled successfully.",
  "profile.redirecting": "Redirecting...",
  "profile.yourRating": "Your rating",
  "profile.reviewComment": "Your review",
  "profile.reviewCommentPlaceholder": "Share your experience with this tour...",
  "profile.sendReview": "Send review",
  "profile.reviewSuccess": "Review submitted. Thank you!",
  "profile.cancelReasons.cambio_fechas": "Change of dates",
  "profile.cancelReasons.emergencia_personal": "Personal emergency",
  "profile.cancelReasons.mal_clima": "Bad weather",
  "profile.cancelReasons.encontrar_mejor_precio": "Found a better price",
  "profile.cancelReasons.doble_reserva": "Double booking",
  "profile.cancelReasons.otro": "Other",
  "profile.activityLog": "Booking timeline",
  "profile.timeline.booking_created": "Booking created",
  "profile.timeline.payment_received": "Payment received",
  "profile.timeline.booking_confirmed": "Booking confirmed",
  "profile.timeline.reminder_sent": "Reminder sent",
  "profile.timeline.tour_completed": "Tour completed",
  "profile.timeline.review_requested": "Review requested",
  "profile.timeline.booking_cancelled": "Booking cancelled",
  "profile.timeline.refund_processed": "Refund processed",
  "profile.reviews": "reviews",
  "profile.saving": "Saving…",
  "profile.loading": "Loading…",
  "profile.notif.all": "All",
  "profile.notif.unread": "Unread",
  "profile.notif.markAllRead": "Mark all as read",
  "profile.notif.preferences": "Preferences",
  "profile.notif.empty": "You have no notifications.",
  "profile.notif.justNow": "Just now",
  "profile.notif.minsAgo": "{{n}} min ago",
  "profile.notif.hoursAgo": "{{n}} h ago",
  "profile.notif.daysAgo": "{{n}} d ago",
  "profile.notifEmail": "Email",
  "profile.notifEmailDesc": "Booking confirmations and important notices by email.",
  "profile.notifWhatsApp": "WhatsApp",
  "profile.notifWhatsAppDesc": "Confirmations and reminders by WhatsApp.",
  "profile.prefsSaved": "Preferences saved.",

  // EN parity: overview, stats, notifications prefs, security, account deletion
  "profile.activeNow": "Active now",
  "profile.activeSessions": "Active sessions",
  "profile.backHome": "Back to home",
  "profile.cancelBooking": "Cancel booking",
  "profile.changePassword": "Change password",
  "profile.changePasswordDesc": "For your security, we email you a link to change your password.",
  "profile.sendResetLink": "Email me the link",
  "profile.sendingResetLink": "Sending…",
  "profile.resetLinkSent": "Done. Check your inbox (and your spam folder).",
  "profile.resetLinkError": "We couldn't send the link. Please try again later.",
  "profile.continueDelete": "Continue",
  "profile.currentDevice": "This device",
  "profile.deleteAccountBtn": "Delete my account",
  "profile.deleteConfirm": "I understand this action is irreversible",
  "profile.deleteDoneDesc": "We're sorry to see you go. Your account has been deleted.",
  "profile.deleteDoneTitle": "Account deleted",
  "profile.deleteLoss1": "You will lose all your bookings and vouchers",
  "profile.deleteLoss2": "Your reviews will be deleted",
  "profile.deleteLoss3": "You won't be able to recover your account",
  "profile.deleteReasonDesc": "Your feedback helps us improve",
  "profile.deleteReasonTitle": "Why are you leaving?",
  "profile.deleteTitle": "Are you sure?",
  "profile.emailBookingsDesc": "Receive an email when you confirm a booking",
  "profile.emailBookingsLabel": "New booking",
  "profile.emailNewsletterDesc": "Receive our monthly newsletter",
  "profile.emailNewsletterLabel": "Newsletter",
  "profile.emailNotifications": "Email notifications",
  "profile.emailPromosDesc": "Receive special offers and discounts",
  "profile.emailPromosLabel": "Promotions",
  "profile.leaveReview": "Leave a review",
  "profile.myBookings": "My bookings",
  "profile.myFavorites": "My favorites",
  "profile.myReviews": "My reviews",
  "profile.noReviews": "You haven't left any reviews yet",
  "profile.overview": "Overview",
  "profile.pushBookingsDesc": "Notifications before your tour",
  "profile.pushBookingsLabel": "Booking reminders",
  "profile.pushNotifications": "Push notifications",
  "profile.pushReviewsDesc": "When someone replies to your reviews",
  "profile.pushReviewsLabel": "New reviews",
  "profile.reason1": "I couldn't find the tours I was looking for",
  "profile.reason2": "Prices are too high",
  "profile.reason3": "I had a bad experience",
  "profile.reason4": "Other",
  "profile.recentBookings": "Recent bookings",
  "profile.saved": "Saved",
  "profile.security": "Security",
  "profile.smsRemindersDesc": "Reminders by text message",
  "profile.smsRemindersLabel": "SMS",
  "profile.statsBookings": "Bookings",
  "profile.statsFavorites": "Favorites",
  "profile.statsReviews": "Reviews",
  "profile.statsSavings": "Savings",
  "profile.twoFactor": "Two-factor authentication",
  "profile.twoFactorDesc": "Add an extra layer of security to your account",
  "profile.viewAll": "View all",
  "profile.viewVoucher": "View voucher",
  "profile.loadError": "We couldn't load the information. Please try again.",
  "profile.saveError": "We couldn't save your changes. Please try again.",
  "profile.emailReadOnly": "To change your email, contact us from the contact page.",
  "profile.statsSpent": "Total",
  "profile.discount": "Discount",
  "profile.reviewTitle": "Title (optional)",
  "profile.reviewError": "We couldn't submit your review. Please try again.",
  "profile.reviewNotOwner": "You can't review this booking.",
  "profile.reviewOnlyCompleted": "You can only leave a review after the tour has finished.",
  "profile.cancelNotAllowed": "This booking can no longer be cancelled.",
  "profile.cancelError": "We couldn't cancel the booking. Please try again.",
  "profile.removeFromFavorites": "Remove from favorites",
  "profile.currentDeviceInfo": "Chrome · La Paz, México",
};